import { GenericResource, IHttpAgent } from '@sparelabs/http-client-utils'
import {
  IAppointmentPatchBody,
  IAppointmentPostBody,
  IAppointmentResponse,
  IListAppointmentQueryParams,
} from '../types'
import { Resources } from './ResourcesType'

export class AppointmentResource extends GenericResource<
  IAppointmentResponse,
  IListAppointmentQueryParams,
  IAppointmentPatchBody,
  IAppointmentPostBody
> {
  public get = this.buildGet()
  public list = this.buildList()
  public post = this.buildPost()
  public patch = this.buildPatch()
  constructor(agent: IHttpAgent) {
    super(Resources.Appointments, agent)
  }

  public async cancel(appointmentId: string): Promise<void> {
    await this.agent.post(`${this.resource}/${appointmentId}/cancel`)
  }
}
